import axios from "axios";
import ErrorParser from '../error.parser';

const NamespaceService = {
  get: async function () {
    const requestData = {
      method: "get",
      url: "/api/settings/namespace",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  save: async function (namespace) {
    const requestData = {
      method: "post",
      url: "/api/settings/namespace/save",
      data: {namespace: namespace}
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }
};

export default NamespaceService;
